import {ScreenLock} from "../../__constants/lock-screen";

const $ = jQuery.noConflict();

export default class Search {
    constructor() {
        this.openTrigger = $('button.search-trigger');
        this.form = $('.search-form');
        this.searchWrapper = $('.search-wrapper');
        this.searchResults = this.searchWrapper.find('.search-results');
        this.searchInput = this.searchWrapper.find('input[type="search"]');
        this.closeTrigger = this.searchWrapper.find('.close');
    }

    initTriggers() {
        this.openTrigger.on('click', () => {
            this.openSearch();
        });

        this.closeTrigger.on('click', () => {
            this.closeSearch();
        });

        this.form.on('submit', e => {
            e.preventDefault();
            this.ajax()
        });

        this.searchInput.on('change', () => this.ajax());
    }

    openSearch() {
        this.searchWrapper.addClass('active');
        ScreenLock.lock();
    }

    closeSearch() {
        this.searchWrapper.removeClass('active');
        this.searchResults.html('');
        ScreenLock.unlock();
    }

    ajax() {
        const searchValue = this.searchInput.val();
        $.ajax({
            method: 'POST',
            url: `${WP.apiUrl}search/`,
            data: {
                term: searchValue,
            },
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', WP.apiNonce);
            },
            success: (response) => {
                this.searchResults.html(response.content);
            },
            fail: (response) => {
                console.log('fail', response);
            }
        });
    }
}
